import React, {useRef, useState} from "react";
import './fileSearcher.css';
import FileRow from "../myDrive/fileRow/fileRow";
import functions from "../../../utils/functionsFirebase";

function FileSearcher({title, onOpenFile, searching, setSearching}) {

    const [search, setSearch] = useState("");
    const searchInput = useRef(null);
    const [foundFiles, setFoundFiles] = useState([]);
    const [searchingTimeout, setSearchingTimeout] = useState(null);
    const [loadingSearch, setLoadingSearch] = useState(false);

    const handleSearchClick = () => {
        if (!searching) {
            setSearching(true);
            setTimeout(() => searchInput.current.focus(), 100);
        }
    };

    const handleCancelButtonClick = (e) => {
        setSearching(false);
        setSearch('');
        setFoundFiles([]);
    };

    const handleInputBlur = () => {
        setTimeout(() => {
            if (searching) {
                setSearching(false);
            }
        }, 100);
    };

    const makeSearch = async (value) => {
        clearTimeout(searchingTimeout);
        setSearchingTimeout(null);
        const findFilesBySearch = functions.httpsCallable("findFilesBySearch");
        const result = await findFilesBySearch({search: value});
        setFoundFiles(result.data.files);
        setLoadingSearch(false);
    }

    const handleSearching = (e) => {
        setSearch(e.target.value)
        if (searchingTimeout) {
            setLoadingSearch(false);
            clearTimeout(searchingTimeout);
        }
        if (e.target.value.trim() === "") {
            setFoundFiles([]);
            return;
        }
        setLoadingSearch(true);
        setSearchingTimeout(setTimeout(() => makeSearch(e.target.value), 700));
    }

    return (
        <div className="col-12 file_searcher"
             style={{position: "relative", height: '38px'}}>
            <div
                className={"w-100 border border-2 d-flex align-items-center " + ((foundFiles.length > 0 && searching) ? 'rounded-top' : 'rounded')}
                style={{position: "relative", height: '38px'}}>
                <div hidden={!searching} style={{position: "absolute", zIndex: 2, right: 0}}
                     className="fileSearcher__buttonSearch"
                     onClick={handleCancelButtonClick}>
                    <i style={{cursor: "pointer"}} className="fa-solid fa-times pe-4"></i>
                </div>
                <div hidden={!loadingSearch} style={{position: "absolute", zIndex: 1, right: '0px'}}>
                     <i className="fa-solid fa-spinner fa-spin me-1"></i>
                </div>
                <div style={{position: "absolute", zIndex: searching ? -1 : 1, height: '100%'}}
                     onClick={handleSearchClick}
                     className={"col-12 ps-2 pe-2 d-flex justify-content-between align-items-center " + (!searching && "fileSearcher__buttonSearch")}>
                <span
                    className={(searching ? 'text-muted' : '') + ' text-truncate'}>{(!searching || !search) ? (search ? search : title) : ""}&nbsp;</span>
                    {!searching && <i className="fa-solid fa-magnifying-glass pe-2"></i>}
                </div>
                <input className="link-body-emphasis col-12 pe-5 ps-2 form-control border-0" value={search}
                                     onBlur={handleInputBlur} hidden={!searching}
                                     style={{border: "none", boxShadow: "none", background: "none", zIndex: 1}}
                                     ref={searchInput} onChange={handleSearching}/>
            </div>
            {foundFiles.length > 0 && searching &&
                <div id="searchResults" style={{position: 'absolute', zIndex: 4, maxHeight: '285px', overflowY: 'auto'}}
                     className="w-100">
                    <div className="list-group ">
                        {foundFiles.map((file, i) => <FileRow selected={false} isFolder={false}
                                                              loading={false} onClick={onOpenFile} showOptions={false}
                                                              key={file.id} params={file} active={false}
                                                              draggable={false} singleClick={true}
                                                              customClass={"border-top-0 " + (!i && "rounded-0")}
                                                              hideInfo={false}
                                                              customStyleName={{
                                                                  fontSize: 'small',
                                                                  whiteSpace: "nowrap",
                                                                  overflow: 'hidden',
                                                                  textOverflow: 'ellipsis',
                                                              }}
                                                              customStyleIcon={{
                                                                  fontSize: 'small',
                                                                  width: window.innerWidth < 768 ? '0px' : '10px',
                                                              }}
                                                              customClassIcon={window.innerWidth < 768 && "fileRow__hideIcon"}
                                                              customClassName={window.innerWidth < 768 && "col-12"}>
                        </FileRow>)}
                    </div>
                </div>}
        </div>

    )

}

export default FileSearcher;
